import useMatchedPath from './useMatchedPath';
export default useMatchedPath;
